import { useState } from 'react'
// import { Accordion } from '@prosolve/common-components-ui'
import SkillCard from "../../FeedbackWizardView/FeedbackWizardResultsView/SkillCard"
import StrandDetails from "./StrandDetails";

const isValidHex6 = (str) => {
  return /^#?[0-9a-fA-F]{6}$/.test(str);
}

export default ({
  teamColor: teamColorRaw = '',
  teamName = '',
  whatIfsNum,
  strands = [],
  finalScore,
  humanScore,
  rank,
  isSingleView,
  isLast
}) => {
  const teamColorMap = {
    Green: '12de2d',
    Blue: '2a94ff',
    Yellow: 'ff920d',
    Purple: 'db49f8',
    Black: '758189',
    Red: 'ff1f25',
  }

  const teamColor = teamColorMap[teamColorRaw] || teamColorRaw;

  const teamColorHex = `#${teamColor}`

  const skillDisplayNameMap = {
    'Critical_Thinking': 'Critical Thinking',
    'Creative_Thinking': 'Creative Thinking',
    'Resilience': 'Resilience',
  }

  const topStrands = []

  strands
    .filter(({ score_percentage }) => score_percentage > 0)
    .forEach(strand => {
    const {
      skill_name = ''
    } = strand;
    if (topStrands.findIndex(({ skill_name: sn }) => sn === skill_name) < 0) {
      topStrands.push({ skill_name })
    }
  });

  topStrands.forEach(topStrand => {
    const {
      skill_name = ''
    } = topStrand;

    const substrands = strands.filter(({ skill_name: sn, score_percentage }) => (score_percentage > 0 && sn === skill_name))

    let total = 0;
    substrands.forEach(({ score_percentage }) => {
      total += score_percentage;
    });

    const averageScore = total / substrands.length;

    const subSkills = substrands.length > 0 ? substrands : []

    topStrand.score_percentage = averageScore
    topStrand.subSkills = subSkills;
  });

  const formatScore = (score) => {
    return Math.round(score) // Math.round(score * 100) / 100 
  }

  const [strandDetails, setStrandDetails] = useState()

  const onStrandClick = (strand) => {
    setStrandDetails(strand)
  }

  const onClickTeamName = () => {
    if (!isSingleView) {
      const url = new URL(window.location.href);
      url.searchParams.set("teamName", teamName);
      window.location.href = url.toString(); // full reload
    }
  }

  const title = 
  <div style={{
    display: 'flex',
    alignItems: 'center',
    fontFamily: '"PassionOne-Regular", "Open Sans", sans-serif',
    marginBottom: '20px'
  }}>
    {
      isSingleView ?
      <div style={{
        fontSize: '64px',
        color: `${isValidHex6(teamColorHex) ? teamColorHex : '#c4c4c4'}`,
        // borderRadius: '50%',
        // height: '100px',
        // width: '100px',
        // display: 'flex',
        // alignItems: 'center',
        // justifyContent: 'center'
      }}>
        {'Team:'}
      </div> 
      :
      <div style={{
        fontSize: '100px',
        border: `10px solid ${isValidHex6(teamColorHex) ? teamColorHex : '#c4c4c4'}`,
        borderRadius: '50%',
        height: '100px',
        width: '100px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div>{rank}</div>
      </div>
    }
    <div style={{ 
      // flex: 1,
      fontSize: '64px', 
      textAlign: 'left',
      // color: '#ffffff',
      padding: '20px',
      cursor: isSingleView ? 'default' : 'pointer'
      // border: '1px solid #c4c4c4',
      }}
      onClick={onClickTeamName}
      >
        {teamName}
        {/* {`Score for Team: ${teamName || '-'}, Color: ${teamColor || '-'}`} */}
    </div>
    <div style={{ flex: 1 }}>&nbsp;</div>
    <div style={{ 
      fontSize: '64px',
      marginRight: '20px'
    }}>
      {formatScore(finalScore)}
    </div>
  </div>

  const completeStrandMap = {
    'Critical Thinking': [
      'Analysis',
      'Investigation',
      'Evaluation',
      'Judgment'
    ],
    'Creative Thinking': [
      'Imagination',
      'Connection',
      'Purpose',
      'Experimentation'
    ],
    'Collaboration': [
      'Contribution',
      'Relationship Skills',
      'Integration',
      'Conflict Navigation'
    ],
    'Communication': [
      'Expression',
      'Listening',
      'Dialogue',
      'Perspective'
    ],
    'Resilience': [
      'Advancing',
      'Recovering',
      'Learning',
      'Facing'
    ],
  }


  const completeStrands = (skill_name, strands) => {
    const skillName = skillDisplayNameMap[skill_name] || skill_name;

    const fullStrands = completeStrandMap[skillName] || []

    const completeStrands = fullStrands.map(strandName => {
      const matchedStrand = strands.find(({ strand_name }) => strand_name === strandName)
      if (matchedStrand) {
        return matchedStrand
      } else {
        return {
          skill_name,
          strand_name: strandName
        }
      }
    });

    return completeStrands;
  }

  return (
    <div style={{ padding: '20px', borderBottom: ( isLast || isSingleView) ? 'none' : '1px solid #c4c4c4' /* border: '1px solid #c4c4c4', borderRadius: '10px' */ }}>
    {/* <Accordion title={title} headerExpands={true} defaultOpen={isSingleView}> */}
      {/* <div style={{ 
        fontSize: '48px', 
        marginBottom: showTabSelector ? '20px' : '50px',
        textAlign: 'center',
        fontFamily: '"PassionOne-Regular", "Open Sans", sans-serif'
      }}>
        {`Score for Team: ${teamName || '-'}, Color: ${teamColor || '-'}`}
      </div> */}
      <>
      {
        Boolean(strandDetails) &&
        <StrandDetails
          data={strandDetails}
          onClose={() => setStrandDetails(undefined)}
        />
      }
      {title}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        fontFamily: '"PassionOne-Regular", "Open Sans", sans-serif',
        margin: '0px 5px 20px 5px',
        fontSize: '32px'
      }}>
        <div style={{ flex: 1 }}>
          {`Human Skills score: ${formatScore(humanScore || 0)}%`}
        </div>
        <div>
          {`Number of "What Ifs" found: ${whatIfsNum || 0}`}
        </div>
      </div>
      {
        !isSingleView ?
        <></>
        :
        topStrands.length > 0 ?
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '20px',
          marginBottom: '20px'
        }}>
          {
            topStrands.map((skillsData) => {
              const { skill_name = '', score_percentage = '', subSkills = [] } = skillsData;
              const skillName = skillDisplayNameMap[skill_name] || skill_name;
              const score = Math.round(score_percentage)

              const processedSubSkills = completeStrands(skill_name, subSkills)

              return (
                <SkillCard key={skillName} skillName={skillName} score={score} subSkills={processedSubSkills} hideOverall={false} onStrandClick={onStrandClick} />
              )
            })
          }
        </div>
        :
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          border: "1px solid #C2C9D1",
          borderRadius: "20px",
          overflow: 'hidden',
          background: '#ffffff',
          color: '#565656',
          padding: '20px',
          width: '50%',
          justifySelf: 'center',
          boxSizing: 'border-box',
          marginBottom: '20px'
        }}>
          <div style={{ flex: 1, textAlign: 'center', }}>
            {'No metrics found'}
          </div>
        </div>
      }
      </>
    {/* </Accordion> */}
    </div>
  )
}